function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, nav-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    if (!this.header) return; // No section-header on the page — nothing to anchor to.
    // The Refind header uses .header-refind-wrapper, not .header-wrapper, so
    // .closest() returns null in that layout. Guard against it. Compute
    // borderOffset directly each call: the original `this.borderOffset || expr`
    // pattern was a buggy memoization (sticky-at-1, re-evaluating at 0).
    const wrapper = this.closest('.header-wrapper');
    this.borderOffset = (wrapper && wrapper.classList.contains('header-wrapper--border-bottom')) ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

/* Fold a designer name down to a comparison key for the drawer's filter:
   lowercased, diacritics stripped, and every non-alphanumeric dropped. That
   last step is what makes the filter forgiving of how the store writes its
   vendor names — "alaia" finds "Alaïa", "aliceo" and "alice o" both find
   "Alice + Olivia", and "agjeans" finds "AG Jeans". */
function normalizeDesignerName(value) {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

/* <nav-drawer>: COS-style two-pane drawer for the Refind header.
   - Single canonical <summary> trigger inside .header-refind__primary.
   - One or more forwarder <button data-nav-drawer-trigger> in the DOM (e.g.
     a mobile-only one in the right utility cluster) forward clicks to the
     canonical <summary> via summary.click(), so native <details> semantics
     remain the source of truth.
   - Tracks lastTrigger so focus returns to whichever hamburger the user
     actually pressed, not the (possibly hidden) canonical summary.
   - Hover/focus on a left-pane category swaps the right pane. Click on the
     category title navigates on desktop; on mobile it slides the right
     pane over the left pane instead. */
class NavDrawer extends HeaderDrawer {
  constructor() {
    super();
    this.canonicalSummary = this.querySelector('summary');
    this.lastTrigger = this.canonicalSummary;
    this.panes = this.querySelector('.nav-drawer__panes');
    this.categories = this.querySelectorAll('.nav-drawer__category');
    this.detailPanels = this.querySelectorAll('.nav-drawer__detail');
    this.mobileMQ = window.matchMedia('(max-width: 749px)');
    // Read close animation duration from the design token. The CSS slide-out
    // on `.nav-drawer` uses --dur-hover; matching the JS [open]-strip timer
    // to the same token avoids the panel snapping invisible mid-slide.
    const durHover = getComputedStyle(document.documentElement).getPropertyValue('--dur-hover').trim();
    this.closeAnimationDuration = parseInt(durHover, 10) || 300;
    this.hoverCloseTimer = null;
    this.hoverOpenRaf = null;
    this.delegatedForwarderListener = null;

    this.bindCategoryActivation();
    this.bindMobileSlideOver();
    this.bindDesignerFilter();

    // mousedown on canonical summary records it as the last trigger before
    // the click handler runs. The forwarder path sets lastTrigger before
    // dispatching the synthetic summary.click(), so the two sources don't
    // race — whichever physical element the user pressed wins.
    if (this.canonicalSummary) {
      this.canonicalSummary.addEventListener('mousedown', () => {
        this.lastTrigger = this.canonicalSummary;
      });
      this.canonicalSummary.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.lastTrigger = this.canonicalSummary;
        }
      });
    }
  }

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.mainDetailsToggle) {
      // Mirror the canonical [open] attribute onto external forwarder buttons
      // so their hamburger ↔ X icon morph stays in sync without us having to
      // hand-call setAttribute on every open/close path.
      this.openObserver = new MutationObserver(() => this.syncForwarderState());
      this.openObserver.observe(this.mainDetailsToggle, { attributes: true, attributeFilter: ['open'] });
    }

    // Forwarders are bound via document-level delegation so theme-editor
    // re-renders that swap the right utility cluster (or any other DOM
    // containing the forwarder) don't leave stale or unbound buttons.
    if (!this.delegatedForwarderListener) {
      this.delegatedForwarderListener = (event) => {
        const btn = event.target.closest('[data-nav-drawer-trigger]');
        if (!btn) return;
        if (btn.getAttribute('aria-controls') !== this.mainDetailsToggle?.id) return;
        event.preventDefault();
        this.lastTrigger = btn;
        if (this.canonicalSummary) this.canonicalSummary.click();
      };
      document.addEventListener('click', this.delegatedForwarderListener);
    }
  }

  disconnectedCallback() {
    if (this.openObserver) this.openObserver.disconnect();
    if (this.delegatedForwarderListener) {
      document.removeEventListener('click', this.delegatedForwarderListener);
      this.delegatedForwarderListener = null;
    }
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
    if (this.hoverOpenRaf) {
      cancelAnimationFrame(this.hoverOpenRaf);
      this.hoverOpenRaf = null;
    }
  }

  // Live getter so JS can always find the current forwarders even after a
  // theme-editor re-render replaces the right utility cluster.
  get forwarders() {
    if (!this.mainDetailsToggle) return [];
    const id = this.mainDetailsToggle.id;
    return document.querySelectorAll(`[data-nav-drawer-trigger][aria-controls="${id}"]`);
  }

  bindCategoryActivation() {
    this.categories.forEach((cat) => {
      const handle = cat.dataset.categoryHandle;
      const link = cat.querySelector('.nav-drawer__category-link');

      // Desktop hover/focus: swap the right pane to this category.
      cat.addEventListener('mouseenter', () => {
        if (this.mobileMQ.matches) return;
        this.activateCategory(handle);
      });
      if (link) {
        link.addEventListener('focus', () => {
          if (this.mobileMQ.matches) return;
          this.activateCategory(handle);
        });
      }

      // Mobile click: open the slide-over instead of navigating. Subcategory
      // links (including "All <Category>") still navigate normally.
      //
      // A trigger rendered as a <button> (the By Designer group with no
      // landing URL) has nowhere to navigate, so it activates at every
      // breakpoint — that's also the only way a coarse-pointer tablet above
      // 750px, which never fires mouseenter, can swap the right pane.
      if (link) {
        const isButton = link.tagName === 'BUTTON';
        link.addEventListener('click', (event) => {
          if (!this.mobileMQ.matches && !isButton) return;
          event.preventDefault();
          this.activateCategory(handle);
          if (this.mobileMQ.matches) this.openDetail();
        });
      }
    });
  }

  bindMobileSlideOver() {
    this.querySelectorAll('.nav-drawer__back').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeDetail();
      });
    });
  }

  // Keyword narrowing for the By Designer list. Deliberately *not* a search:
  // it only toggles [hidden] on rows that are already in the DOM, so there's
  // no request, no results route, and no state worth persisting. The list is
  // static Liquid output, so the comparison keys are built once here rather
  // than re-read from the DOM on every keystroke (~90 rows either way, but
  // this keeps the input handler free of layout reads).
  bindDesignerFilter() {
    this.designerFilter = this.querySelector('.nav-drawer__designer-filter');
    this.designerList = this.querySelector('.nav-drawer__designer-list');
    if (!this.designerFilter || !this.designerList) return;

    this.designerEmpty = this.querySelector('.nav-drawer__designer-empty');
    this.designerStatus = this.querySelector('.nav-drawer__designer-status');
    this.designerDetail = this.designerList.closest('.nav-drawer__detail');
    this.designerRows = Array.from(this.designerList.querySelectorAll('li')).map((row) => ({
      row,
      key: normalizeDesignerName(row.textContent),
    }));

    this.designerFilter.addEventListener('input', () => this.applyDesignerFilter());

    // Enter follows the first surviving match. With no <form> ancestor the
    // key is otherwise inert, and on mobile this saves dismissing the
    // keyboard to tap a link that's already the only one on screen.
    this.designerFilter.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      // An IME sends Enter to commit a candidate. Swallowing that breaks
      // composition, and because a CJK query normalizes to nothing and so
      // hides no rows, "first surviving match" would be whichever designer
      // happens to be first in the list.
      if (event.isComposing || event.keyCode === 229) return;
      // The same trap without an IME: on an empty field nothing is hidden,
      // so the first surviving match is row one. Enter in an empty search
      // box is a reflex, and the default action of a soft keyboard's Go
      // key — neither should navigate anywhere.
      if (this.designerFilter.value.trim() === '') return;
      event.preventDefault();
      const hit = this.designerRows.find((entry) => !entry.row.hidden);
      const link = hit && hit.row.querySelector('a');
      if (link) link.click();
    });

    // Reconcile the rows against the field once at bind time. Firefox
    // restores form state on history navigation even with autocomplete
    // off, and a re-parsed page brings the rows back unhidden with no
    // input event to catch it — leaving the field reading "prada" over a
    // list of all ninety designers.
    this.applyDesignerFilter();
  }

  applyDesignerFilter() {
    if (!this.designerRows) return;
    // Two different kinds of empty, and they mean opposite things. A blank
    // field is "no filter". A field holding only punctuation or non-Latin
    // script normalizes away to nothing but is still a query the user
    // typed, and it has to read as zero results — treating it as "no
    // filter" shows all ninety names under text that appears to be a
    // search, which reads as a broken field rather than an empty result.
    const typed = this.designerFilter.value.trim();
    const query = normalizeDesignerName(typed);
    let matches = 0;

    this.designerRows.forEach((entry) => {
      const hit = typed === '' || (query !== '' && entry.key.indexOf(query) !== -1);
      entry.row.hidden = !hit;
      if (hit) matches += 1;
    });

    this.setDesignerMessage(matches === 0 ? 'No designers match that name.' : '');
    // Narrowing while scrolled down otherwise parks the user past the end of
    // the shorter list, which reads as an empty pane.
    this.designerList.scrollTop = 0;
  }

  // The visible <p> is aria-hidden and purely decorative; the announcement
  // rides on a visually-hidden role="status" that is always rendered, because
  // a live region that flips from display:none to visible-with-text in one
  // tick is missed by NVDA and JAWS often enough not to rely on.
  //
  // Both writes are guarded: assigning textContent rebuilds the text node
  // even when the string has not changed, and a live region treats that as a
  // fresh mutation — so typing "zzzz" past the last match would otherwise
  // announce "no designers match" four times, each cutting off the last.
  setDesignerMessage(message) {
    if (this.designerEmpty && this.designerEmpty.textContent !== message) {
      this.designerEmpty.textContent = message;
    }
    if (this.designerStatus && this.designerStatus.textContent !== message) {
      this.designerStatus.textContent = message;
    }
  }

  // No focus side effects, so this is safe on every path that hides the
  // designer pane — including the drawer-close paths, where focusing a
  // panel child would bubble focusin to <refind-shop-pane> and reopen us.
  clearDesignerFilter() {
    if (!this.designerFilter || this.designerFilter.value === '') return;
    this.designerFilter.value = '';
    this.applyDesignerFilter();
  }

  activateCategory(handle) {
    this.categories.forEach((cat) => {
      const isActive = cat.dataset.categoryHandle === handle;
      cat.classList.toggle('is-active', isActive);
      // Only button triggers carry aria-expanded (an <a> that navigates
      // isn't a disclosure control), so this no-ops for the anchor case.
      const trigger = cat.querySelector('button.nav-drawer__category-link');
      if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
    this.detailPanels.forEach((panel) => {
      panel.toggleAttribute('hidden', panel.dataset.categoryDetailFor !== handle);
    });
    // Switching to another category drops the filter, so coming back to By
    // Designer later starts from the full list instead of a stale narrowing.
    if (this.designerDetail && this.designerDetail.hidden) this.clearDesignerFilter();
  }

  openDetail() {
    if (this.panes) this.panes.classList.add('is-detail-open');
  }

  // State-only reset of the mobile slide-over. No focus side effects, so
  // it's safe to call from the drawer-close paths (closeFromHover,
  // syncForwarderState) without triggering a focusin → reopen loop.
  resetDetail() {
    if (this.panes) this.panes.classList.remove('is-detail-open');
    this.clearDesignerFilter();
  }

  // Mobile back-button path: dismiss the slide-over and return focus to
  // the active category link in the left pane so keyboard users land
  // somewhere meaningful. DO NOT call this from any path where the whole
  // drawer is closing — focusing a panel child while the panel is sliding
  // offscreen bubbles focusin up to <refind-shop-pane>'s panel listener,
  // which calls open() and re-asserts [open], stranding the drawer in a
  // half-open state until the user re-interacts.
  closeDetail() {
    this.resetDetail();
    const active = this.querySelector('.nav-drawer__category.is-active .nav-drawer__category-link');
    if (active) active.focus();
  }

  syncForwarderState() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.forwarders.forEach((btn) => {
      btn.classList.toggle('is-open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    // Reset the mobile slide-over when the drawer fully closes so the next
    // open starts with the active category visible in the left-pane stack
    // rather than dropping the user back into a half-open detail panel.
    // resetDetail (not closeDetail) — closeDetail focuses a panel child,
    // which bubbles focusin to shop-pane and re-triggers open() while the
    // drawer is meant to be closing.
    if (!isOpen) this.resetDetail();
  }

  closeMenuDrawer(event, elementToFocus) {
    // Restore focus to whichever physical trigger most recently opened the
    // drawer — on mobile the canonical <summary> is display:none, so
    // routing focus there would lose the focus ring entirely.
    super.closeMenuDrawer(event, this.lastTrigger || elementToFocus);
  }

  // The parent MenuDrawer auto-binds onCloseButtonClick to *every* <button>
  // inside the drawer (it was designed for nested <details> submenu close
  // buttons). That handler calls closeSubmenu(closest('details')), and
  // because the closest <details> is the main nav drawer itself, tapping
  // our mobile back button would tear down the whole drawer. Re-implement
  // the bindings without that generic button binding — our own back-button
  // listener (bindMobileSlideOver) handles the slide-over close cleanly.
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
  }

  // Hover-driven open. Bypasses MenuDrawer's openMenuDrawer (which traps
  // focus on the visually-hidden <summary> — feels jolty for hover) by
  // manipulating [open] and .menu-opening directly. Used by
  // <refind-shop-pane> on the SHOP zone hover.
  openFromHover() {
    if (!this.mainDetailsToggle) return;
    // Cancel any in-flight close timer so rapid open/close/open cycles
    // don't strip [open] right after we just set it.
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
    // Cancel any pending open frame from a previous openFromHover so we
    // don't double-add menu-opening.
    if (this.hoverOpenRaf) {
      cancelAnimationFrame(this.hoverOpenRaf);
      this.hoverOpenRaf = null;
    }
    if (this.mainDetailsToggle.hasAttribute('open') &&
        this.mainDetailsToggle.classList.contains('menu-opening')) {
      return; // already fully open
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      // Add menu-opening on the next frame so the CSS transition runs.
      // Using requestAnimationFrame ensures the [open] attribute has been
      // committed and the browser has computed initial styles. We track
      // the frame id so closeFromHover can cancel it — without that, a
      // hover-on/hover-off cycle that completes before this frame runs
      // would still get menu-opening added after closeFromHover stripped
      // it, leaving the drawer stuck open.
      this.hoverOpenRaf = requestAnimationFrame(() => {
        this.hoverOpenRaf = null;
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.classList.add('menu-opening');
        }
      });
    } else {
      // Mid-close — re-add menu-opening to abort the close animation.
      this.mainDetailsToggle.classList.add('menu-opening');
    }
    if (this.canonicalSummary) {
      this.canonicalSummary.setAttribute('aria-expanded', 'true');
    }
  }

  // Hover-driven close. Skips removeTrapFocus (no focus to restore — the
  // user was hovering, not interacting) and mirrors MenuDrawer.closeAnimation
  // for the visual close. Cleans up any body scroll-lock left over from a
  // mobile-forwarder open path so a hybrid touchscreen-laptop session
  // doesn't end with the page un-scrollable.
  closeFromHover() {
    if (!this.mainDetailsToggle) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    // Don't bail when menu-opening isn't set yet — that's exactly the
    // race where the open frame is still queued. Cancel that frame so
    // it can't re-add menu-opening *after* we strip it.
    if (this.hoverOpenRaf) {
      cancelAnimationFrame(this.hoverOpenRaf);
      this.hoverOpenRaf = null;
    }

    if (this.hoverCloseTimer) clearTimeout(this.hoverCloseTimer);

    this.mainDetailsToggle.classList.remove('menu-opening');
    // Reset detail slide-over (mobile) so a future open starts clean.
    // resetDetail (not closeDetail) — closeDetail focuses the active
    // category link, which would bubble focusin back to shop-pane and
    // immediately re-trigger open(), trapping the drawer half-open.
    this.resetDetail();
    if (this.canonicalSummary) {
      this.canonicalSummary.setAttribute('aria-expanded', 'false');
    }
    // If a prior open went through the full MenuDrawer.openMenuDrawer path
    // (mobile forwarder), the body picked up an overflow-hidden-* class
    // and a focus trap was installed. Hover-close needs to undo both —
    // otherwise a session that crosses breakpoints leaves the page
    // un-scrollable and focus trapped inside an empty drawer.
    if (this.dataset.breakpoint) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    // Wait for the CSS transition to complete, then drop [open]. If the
    // user re-hovered in the interim and menu-opening is back, leave
    // [open] alone — the drawer is open again.
    this.hoverCloseTimer = setTimeout(() => {
      this.hoverCloseTimer = null;
      if (this.mainDetailsToggle &&
          !this.mainDetailsToggle.classList.contains('menu-opening')) {
        this.mainDetailsToggle.removeAttribute('open');
      }
    }, this.closeAnimationDuration);
  }

  // Override MenuDrawer.closeAnimation to use our token-driven duration
  // instead of the hardcoded 400ms. The mobile-forwarder close path goes
  // through the parent's closeMenuDrawer → closeAnimation chain; if that
  // ran at 400ms but our CSS transition is 300ms, [open] would stick
  // around 100ms after the panel was already off-screen — harmless but
  // imprecise. Using the same token everywhere keeps timing consistent.
  closeAnimation(detailsElement) {
    let animationStart;
    const duration = this.closeAnimationDuration;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsed = time - animationStart;
      if (elapsed < duration) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('nav-drawer', NavDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
